import React, { useContext } from 'react';
import { ARMcontext } from '../../utils/context/context';
import Media from '../Media/Media';
import { useLocation, useNavigate } from 'react-router-dom';
import { Column, SelectZone } from './styles';
import Teams from '../../utils/api/Teams';

export default (
  { player, padding, unClickeable, cursor, bgColor, PlayerColumnRef }:
    { player: any, padding?: any, unClickeable?: boolean, cursor?: any, bgColor?: any, PlayerColumnRef?: any }
) => {
  const { HandleSelectedPlayer } = useContext(ARMcontext);
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname.split("/");

  async function fetchSelectedPlayerInfo(player_id: string) {
    const playerInfo = await TEAMS.FetchSelectedPlayerInfo(player_id);

    if (playerInfo.success) {
      const exitTo = `${location.pathname}${location.search}`;
      const section: string = path[path.length - 1] ?? '';
      if (section.includes('actionItems') || section.includes('keyMetrics')) {
        navigate('/players/exams', { state: { exitTo } });
        HandleSelectedPlayer(playerInfo.data);
        return;
      }
      navigate(
        { pathname: location.pathname, search: location.search },
        { replace: false, state: { exitTo } },
      );
      HandleSelectedPlayer(playerInfo.data);
    }
  }
  const TEAMS = new Teams();
  if(unClickeable){
    cursor = 'default';
  }
  return (
    <Column bgColor={bgColor} {...(PlayerColumnRef && { ref: PlayerColumnRef })}>
      <SelectZone onClick={() => !unClickeable && fetchSelectedPlayerInfo(player._id)} cursor={cursor}>
        <Media padding={padding} fontSize={'12px'} imgUrl={player.picture} name={`${player.firstName} ${player.lastName}`} />
      </SelectZone>
    </Column>
  );
};
